'use strict'

import _ from 'lodash'

export default {
  /**
   * 엑셀 파일 다운로드
   **/
  getExcelFile(response, fileName) {
      let result = document.createElement('a');

      let blob = new Blob([response.data], {type: response.headers['content-type']})

      //파일이름이 없을 경우 기본 파일이름을 셋팅한다
      // 기본 파일이름 : export_yyyymmdd.xlsx
      fileName = _.isEmpty(fileName) ? 'export' : fileName;
      fileName = fileName+'_'+ _.now() +'.xlsx';

      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.target = '_self';
      link.download = fileName;
      link.click();
  },
  /**
   * 첨부 파일 다운로드
   **/  
  getFile(response, fileName) {
    let result = document.createElement('a');

    let blob = new Blob([response.data], {type: response.headers['content-type']})

    //파일이름이 없을 경우 기본 파일이름을 셋팅한다
    // 기본 파일이름 : export_yyyymmdd.xlsx
    fileName = _.isEmpty(fileName) ? 'export' : fileName;

    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.target = '_self';
    link.download = fileName;
    link.click();
}
}


// WEBPACK FOOTER //
// ./src/modules/file.js